import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useLocalization } from '@contexts/LocalizationContext'
import { Button, Form, Input, InputNumber, Radio } from 'antd'
import UploadImage from './UploadImageFromAntd'
import UploadImageMulti from './UploadImageMultiFromAntd'

const FormComponent = ({
  doStatus,
  handleSubmit,
  defaultValues = { posterImages: [] },
}) => {
  const [form] = Form.useForm()
  const tagValue = Form.useWatch('tag', form)
  console.log('doStatus', doStatus)

  console.log('tagValue', tagValue)
  const { t } = useLocalization()

  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  const style = {
    inputShop: { width: '100%', height: '40px' },
    inputDateForm: { width: '100%', height: '40px' },

    btnStyleSummit: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },

    btnStyleSummitAdd: {
      // height: '37px',
      width: '232px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
  }

  useEffect(() => {
    if (doStatus === 'edit') {
      form.resetFields()
    }
  }, [defaultValues])

  return (
    <Form
      layout="vertical"
      form={form}
      name="control-hooks"
      onFinish={handleSubmit}
      initialValues={defaultValues}
      requiredMark={false}
    >
      <div hidden>
        <Form.Item name="id">
          <Input />
        </Form.Item>
      </div>

      <Form.Item
        name="order"
        defaultValue={defaultValues.order || ''}
        label="ลำดับ"
        rules={[
          {
            required: true,
            message: 'กรุณากรอกลำดับ',
          },
        ]}
      >
        <InputNumber style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="tag"
        rules={[{ required: true, message: 'กรุณาเลือกภาษา' }]}
      >
        <Radio.Group>
          <Radio value={'link'}>Link</Radio>
          <Radio value={'vaccine'}>Vaccine</Radio>
          <Radio value={'PDPA'}>PDPA</Radio>
          <Radio value={'Coupon'}>Coupon</Radio>
          <Radio value={'WellKidzClub'}>WellKidzClub</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name="bannerImage"
        label={t('rewards.list.column.bannerImage')}
        rules={[
          {
            required: true,
            message: t('rewards.list.error.bannerImage'),
          },
        ]}
      >
        <UploadImage defaultValueImg={defaultValues.bannerImage} />
      </Form.Item>

      {tagValue !== 'WellKidzClub' && (
        <Form.Item
          name="url"
          defaultValue={defaultValues.url || ''}
          label="ลิงก์เว็บไซต์"
          rules={[
            {
              // required: true,
              message: 'กรุณากรอกลิงก์เว็บไซต์',
            },
            { type: 'url', warningOnly: true },
          ]}
        >
          <Input style={style.inputShop} />
        </Form.Item>
      )}

      <Form.Item name="posterImages" label="อัปโหลด Poster">
        <UploadImageMulti defaultValueImg={defaultValues.posterImages} />
      </Form.Item>

      {/* เเสดงปุ่ม */}
      <Form.Item {...tailLayout}>
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            htmlType="submit"
            style={style.btnStyleSummitAdd}
          >
            {t('rewards.shop.form.addData')}
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
}

export default FormComponent
